export default __webpack_public_path__ + "static/media/IMG-20241210-WA0015.67e1b7eb.jpg";